import React, { Component } from 'react'
import { Col, Label, Row, Button } from 'reactstrap'
import Card from '../../comum/components/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { inject, observer } from 'mobx-react';
import moment from "moment"
import { Fragment } from 'react';

@inject("store")
@observer
export default class DadosGeraisAcomp extends Component {

    constructor(props){
        super(props)

        this.controller = this.props.controller

        this.campos = []

        this.montarCampos = this.montarCampos.bind(this)
    }

    montarCampos(){
        this.campos = [];        
        if(this.controller.tipoAcompanhamento === "I"){
            process.env.rig ? this.campos = ["BL House","BL Master","Cliente","CNPJ","CE","Navio / Viagem","Modalidade","Armador"] :
                              this.campos = ["BL House","BL Master","Cliente","CE","Navio / Viagem", "Numero DI", "Canal" ];
        }else if(this.controller.tipoAcompanhamento === "C"){
            this.campos = ["CTE","CE","Cliente","Navio / Viagem"];            
        }else if(this.controller.tipoAcompanhamento === "E"){
            process.env.rig ? this.campos = ["Cliente","Booking","Navio / Viagem","Deadline", "Total Containers"] :
                              this.campos = ["Booking","Navio / Viagem", "Total Containers"];    
        }            
    }

    tipoImportacao(tipo){
        switch(tipo){
            case 'I':
                return 'Importação'
            case 'C':
                return 'Cabotagem'
            case 'E':
                return 'Exportação'
            default:
                return null
        }
    }

    render() {
        this.montarCampos()
        return (
            <div>
                <h2 className="d-flex align-items-center">
                    Dados Gerais
                    <Label className="situacao-btn acomp-processo ml-2 mb-0">
                        {this.tipoImportacao(this.controller.tipoAcompanhamento)}
                    </Label>
                    {this.controller.tipoAcompanhamento === "I" && !process.env.rig &&
                        <Label className="situacao-btn acomp-processo ml-2 mb-0">
                            {this.controller.consolidado ? "Consolidado" : "Não consolidado"}
                        </Label>}
                </h2>
                {this.controller.tipoAcompanhamento === "E" && 
                    <div style={{ float: 'right', marginTop: '-42px' }}>
                        <Button 
                            target="blank" 
                            href="https://atendimento.teconline.com.br/hc/pt-br/articles/360039870111-Acompanhamento-de-Processo-Exporta%C3%A7%C3%A3o" 
                            title="Clique aqui para obter ajuda" 
                            className="btn-icon-destaque btn-rounded" 
                        >
                            <FontAwesomeIcon icon={["fas", "question"]} size={"lg"} />
                        </Button>
                    </div>
                }
                {this.controller.tipoAcompanhamento === "I" && 
                    <div style={{ float: 'right', marginTop: '-42px' }}>
                    <Button 
                        target="blank" 
                        href="https://atendimento.teconline.com.br/hc/pt-br/articles/360038794051-Acompanhamento-de-Processo-Importa%C3%A7%C3%A3o" 
                        title="Clique aqui para obter ajuda" 
                        className="btn-icon-destaque btn-rounded" 
                    >
                        <FontAwesomeIcon icon={["fas", "question"]} size={"lg"} />
                    </Button>
                </div>
                }
                <Card>
                    <Row>
                        {this.campos.map((campo, index) => (
                            <Col key={index} xs={12} sm={6} md={4} lg={3} xl={3} >
                                <Label className="label-secondary">
                                    {campo.toUpperCase()}
                                </Label>
                                <div>
                                    {
                                        campo === "Navio / Viagem" ? 
                                        <Label className="label-disabled">
                                        <a onClick={ () => this.controller.abrirModalVesselVisit() } >
                                            {`${this.controller.dadosProcesso[this.camposDadosGerais[campo][0]]}`} 
                                            - 
                                            {`${this.controller.dadosProcesso[this.camposDadosGerais[campo][1]]}`}

                                            <FontAwesomeIcon
                                                icon="external-link-square-alt"
                                                className="ml-1 mb-1 card-detalhe--pop-color card-detalhe--clickable"
                                            />
                                        </a> 
                                        </Label>
                                        :
                                        this.camposDadosGerais[campo] && typeof(this.camposDadosGerais[campo]) !== 'string'
                                        ? <Label className="label-disabled">
                                            {`${this.controller.dadosProcesso[this.camposDadosGerais[campo][0]] ? this.controller.dadosProcesso[this.camposDadosGerais[campo][0]] : "---"}
                                             - 
                                            ${this.controller.dadosProcesso[this.camposDadosGerais[campo][1]] ? this.controller.dadosProcesso[this.camposDadosGerais[campo][1]] : "---"}`}
                                        </Label>
                                        : <Label className="label-disabled">
                                            { campo!="Deadline" ? this.controller.dadosProcesso[this.camposDadosGerais[campo]] ? this.controller.dadosProcesso[this.camposDadosGerais[campo]] : "---" :
                                                                  this.controller.dadosProcesso[this.camposDadosGerais[campo]] ? moment(this.controller.dadosProcesso[this.camposDadosGerais[campo]]).format("DD/MM/YYYY HH:mm") : "---"
                                            }
                                        </Label>
                                    }
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Card>
            </div>
        )
    }

    camposDadosGerais = {
        "BL House":"Documento",
        "BL Master":"BlMaster",
        "Cliente":"Cliente",
        "CNPJ":"Cnpj",
        "CE":"Ce",
        "Navio / Viagem":["Navio", "VesselVisit"],
        "Numero DI": "NumeroDi",
        "Canal" : "Canal",
        "Modalidade":"Modalidad",
        "Armador":"Armador",
        "CTE":"Documento",
        "CE":"Ce",
        "Booking":"Documento",
        "Deadline":"DtDeadline",
        "Total Containers" : "QtdContainer"

    }

}



// WEBPACK FOOTER //
// ./src/modules/acompanhamento/components/DadosGeraisAcomp.js